import { useMemo } from "react";
import { api } from "@/lib/api";
import { useFetch } from "@/lib/ui";
import { useLang } from "@/context/LangContext";
import { Empty, PageHeader } from "@/components/Shell";
import ModulesPanel from "@/components/ModulesPanel";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
const DAY_FR = { Monday: "Lundi", Tuesday: "Mardi", Wednesday: "Mercredi", Thursday: "Jeudi", Friday: "Vendredi" };

export default function LessonPlanner() {
  const { L } = useLang();
  const { data: classes, loading } = useFetch(() => api.get("/schedule/me"));
  const byDay = useMemo(() => {
    const map = {}; DAYS.forEach((d) => (map[d] = []));
    (classes || []).forEach((c) => (c.schedule || []).forEach((s) => { if (map[s.day]) map[s.day].push({ ...s, className: c.name, isTitulaire: !!c.teacher_id && (s.teacher_id || c.teacher_id) === c.teacher_id }); }));
    DAYS.forEach((d) => map[d].sort((a, b) => (a.start || "").localeCompare(b.start || "")));
    return map;
  }, [classes]);
  if (loading) return <Empty title={L("Loading…", "Chargement…")} />;
  return (
    <div className="animate-fade-up">
      <PageHeader title={L("Lesson Planner", "Planificateur de leçons")}
        description={L("Your own weekly teaching schedule and lesson progress — only the classes and slots assigned to you.", "Votre horaire d'enseignement hebdomadaire et la progression des leçons — uniquement les classes et créneaux qui vous sont assignés.")} />
      <p className="font-heading font-bold mb-3">{L("Weekly schedule", "Horaire hebdomadaire")}</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8" data-testid="planner-schedule">
        {DAYS.map((d) => (
          <div key={d} className="bg-card border border-border rounded-lg p-4">
            <p className="font-heading font-bold text-primary mb-3">{L(d, DAY_FR[d])}</p>
            {byDay[d].length === 0 ? <p className="text-xs text-muted-foreground">—</p> : byDay[d].map((s, i) => (
              <div key={i} className="mb-2 border-l-2 border-accent pl-2">
                <p className="text-sm font-medium">{s.subject}</p>
                <p className="text-xs text-muted-foreground">{s.className} · {s.start}–{s.end}</p>
                {s.isTitulaire && <p className="text-[10px] font-semibold text-primary" data-testid="planner-titulaire-badge">{L("Class Teacher", "Titulaire de Classe")}</p>}
              </div>
            ))}
          </div>
        ))}
      </div>
      <p className="font-heading font-bold mb-3">{L("Facilitator Guides & Lesson Progress", "Guides du facilitateur & progression")}</p>
      <ModulesPanel canManage={false} />
    </div>
  );
}
